<div class="no-mission-main-container">
    <div class="museum-card">
        <div class="card-header">
            <h3>{{'no-mission.title' | translate}}</h3>
        </div>
        <div class="museum-card-body">
            <div *ngIf="missionService.lastExpiredMission">{{'no-mission.expiredMuseum' |
                    translate:getMissionParamFunction(missionService.lastExpiredMission, translate)}}</div>
        </div>
        <div class="card-footer">
            <button class="btn rounded-pill btn-museum" (click)="logout()">{{'Logout' | translate}}</button>
        </div>
    </div>
</div>

